import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import Notifications from 'vue-notification'
import VueSVGCustomIcon from 'vue-svg-custom-icon'
import Icon from './components/icon'
import { version } from './../package.json'
import VueAnalytics from 'vue-analytics'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueGtm from 'vue-gtm'

Vue.use(VueVirtualScroller)
Vue.use(VueAnalytics, {
	id: 'UA-126553198-1',
	router
})
Vue.use(VueGtm, {
	id: 'GTM-TBHTBWQ', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
})

Vue.use(Notifications)
Vue.use(VueSVGCustomIcon)
Vue.component('icon', Icon)

window.appVersion = version

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
